import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import FieldView from "../../../../../../../../../components/Form/FieldView";
import { StorageBoxType } from "../../../../../../../../../models/storage.box.type";
import { convertBasicUnits, handleGetConvertValue } from "../../../../../../../../../util/converts";
import { getMeasurement } from "../../../../../../../../../util/getMeasurement";
import { Details } from "./styles";

interface Props {
  value?: StorageBoxType;
}

export const DetailsTab = ({ value }: Props) => {
  const { t: translate } = useTranslation();
  const { convertMetersToMillimeters } = convertBasicUnits();

  return (
    <Details>
      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView label={translate("name")} value={value?.name} />
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView
            label={`${translate("height")} (mm)`}
            value={convertMetersToMillimeters(value?.height)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView
            label={`${translate("width")} (mm)`}
            value={convertMetersToMillimeters(value?.width)}
          />
        </Grid>
      </Grid>

      <Grid container direction="row" alignItems="center" spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView
            label={`${translate("depth")} (mm)`}
            value={convertMetersToMillimeters(value?.depth)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={3}>
          <FieldView
            label={`${translate("capacity")} ${getMeasurement()?.code}`}
            value={handleGetConvertValue(
              value?.capacity || 0,
              getMeasurement()?.code,
              getMeasurement()?.decimalPlaces
            )}
          />
        </Grid>
      </Grid>
    </Details>
  );
};
